import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section_header" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-left",
  style: {"fontSize":"1.5rem"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { style: {"flex":"1"} }, " Negozi ", -1)
const _hoisted_6 = {
  key: 1,
  class: "p-d-flex",
  style: {"gap":"1em"}
}
const _hoisted_7 = {
  key: 2,
  class: "p-d-flex",
  style: {"gap":"2em"}
}
const _hoisted_8 = { class: "p-grid nested-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ShopManagement = _resolveComponent("ShopManagement")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createBlock(_component_GvSpinner, { "is-loading": $setup.isLoading }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Toast, { position: "top-center" }),
        _createElementVNode("div", _hoisted_2, [
          (!$props.isInProfileView)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:;",
                class: "p-mr-2",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
              }, _hoisted_4))
            : _createCommentVNode("", true),
          _hoisted_5,
          (!$setup.isInEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (!$setup.isInEditMode)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "gv-button p-button-outlined",
                      icon: "pi pi-pencil",
                      onClick: $setup.enableEditing
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (!$setup.isInEditMode)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "gv-button p-button-outlined",
                      icon: "pi pi-plus",
                      onClick: $setup.addShop
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.isInEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                ($setup.isInEditMode)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "Annulla",
                      onClick: $setup.cancelChanges,
                      class: "gv-button cancel_button"
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                ($setup.isInEditMode)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "gv-button",
                      disabled: !$setup.areAllStoreValid,
                      label: "Salva",
                      onClick: $setup.saveChanges
                    }, null, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_ShopManagement, {
          "show-avatar": true,
          "fetch-data": true,
          "disable-fields": !$setup.isInEditMode,
          isInProfileView: $props.isInProfileView
        }, null, 8, ["disable-fields", "isInProfileView"])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}